import { AllProductListTableFields } from 'enums/AllProductListEnums';
import { useCallback } from 'react';
import useFarmboxRedirections from './useFarmboxRedirections';
import { CommodityTypes } from 'constants/FarmboxConstants/stage0.constants';

interface RedirectParams {
    productId: number | string;
    mappedStatus: string;
    mappedStage: string;
    commodityType: string;
    adePage: string;
}

export function useRedirectBasedOnProductStatus() {
    const {
        redirectToRespectiveCommodityStage,
        redirectToCommodityOverview,
        redirectToRespectiveLiveStockCommodityStage,
        redirectToLiveStockCommodityOverview,
    } = useFarmboxRedirections();

    const redirect = useCallback(
        ({ productId, mappedStatus, mappedStage, commodityType, adePage }: RedirectParams) => {
            const numericProductId = Number(productId);

            if (mappedStatus === AllProductListTableFields.DECLINED) {
                if (commodityType === CommodityTypes.LIVE_STOCK) {
                    redirectToLiveStockCommodityOverview(Number(productId), mappedStatus, {
                        isFrom: adePage,
                    });
                } else {
                    redirectToCommodityOverview(Number(productId), mappedStatus, {
                        isFrom: adePage,
                    });
                }
            } else {
                if (commodityType === CommodityTypes.LIVE_STOCK) {
                    redirectToRespectiveLiveStockCommodityStage(
                        numericProductId,
                        mappedStage,
                        mappedStatus,
                        {
                            isFrom: adePage,
                        }
                    );
                } else {
                    redirectToRespectiveCommodityStage(
                        numericProductId,
                        mappedStage,
                        mappedStatus,
                        {
                            isFrom: adePage,
                        }
                    );
                }
            }
        },
        [
            redirectToRespectiveCommodityStage,
            redirectToCommodityOverview,
            redirectToRespectiveLiveStockCommodityStage,
            redirectToLiveStockCommodityOverview,
        ]
    );

    return redirect;
}
